import {Diagram, GraphObject, InputEvent, TextBlock, Spot} from 'gojs';

import {APPLICATION_GRAPH_POSITION_STORAGE_KEY} from 'src/constants';
import {GOJS_LICENSE_KEY as LICENSE_KEY} from 'src/gojs-license';

import {MakeDiagramParams} from './types';
import {makeModel} from './model';
import {makeClearDiagramHighlightsFn, makeOnPartDropHandler} from './events';

const {make} = GraphObject;

const makeContextMenu = (resetDiagram: () => void) =>
  make('ContextMenu', // that has one button
      make('ContextMenuButton',
          {
            'ButtonBorder.fill': 'white',
            '_buttonFillOver': 'skyblue',
            'alignment': Spot.Left, 'alignmentFocus': Spot.Right,
          },
          make(TextBlock, 'Reset Graph'),
          {
            click: (_e: InputEvent, obj: GraphObject) => {
              const diagram = obj.diagram;
              if (diagram) {
                localStorage.setItem(APPLICATION_GRAPH_POSITION_STORAGE_KEY, '{}');
                resetDiagram();
              }
            },
          }),
  );

export const makeDiagram = ({navigate, updateDiagram}: MakeDiagramParams) => {
  const resetDiagram = () => updateDiagram();
  Diagram.licenseKey = LICENSE_KEY;
  const diagram =
  make(Diagram, {
    'isModelReadOnly': true, // this is suppose to set read only on the model, but isn't sufficient to prevent node deletion  See:
    'allowCopy': false,
    'panningTool.isEnabled': false,
    'undoManager.isEnabled': false,
    'allowHorizontalScroll': false,
    'allowVerticalScroll': false,
    'animationManager.isInitial': false,
    'allowZoom': false,
    'model': makeModel({navigate}),
    'contextMenu': makeContextMenu(resetDiagram),
  });

  diagram.addDiagramListener('BackgroundSingleClicked', makeClearDiagramHighlightsFn(diagram));
  diagram.addDiagramListener('SelectionMoved', makeOnPartDropHandler(diagram));

  return diagram;
};
